// Adds a class to images and .blocks__text-section when in view
function addInViewClass({
  selector = 'img, .blocks__text-section, .home-hero__subtitle',
  inViewClass = 'inview',
  root = null,
  rootMargin = '0px',
  threshold = 0.1
} = {}) {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  const observer = new window.IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add(inViewClass);
      } else {
        entry.target.classList.remove(inViewClass);
      }
    });
  }, { root, rootMargin, threshold });

  elements.forEach(el => observer.observe(el));
}

// Auto-init on DOMContentLoaded
if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', () => {
    addInViewClass();
  });
}

export { addInViewClass };
